import {container} from "../services/container";
import {Facebook} from "../services/facebook";
import { useState, useEffect, useMemo } from "react";
import {Translate} from "../services/translate";
import React from "react";
import {addUserListener, getCurrentUser, removeUserListener, User, userLogout} from "../models/user";

export function LogoutButton() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // const facebook = useMemo(() => container.get<Facebook>(Facebook), []);
  const translate = useMemo(() => container.get(Translate), []);

    useEffect(() => {
        function listener(user: User | null) {
            setIsLoggedIn(!!user);
        }

        addUserListener(listener);
        // Trigger refresh
        getCurrentUser().catch(console.error);

        return () => removeUserListener(listener);
    }, []);

  // useEffect(() => {
  //   facebook.promise.then(() => {
  //     setIsLoggedIn(!!facebook.lastAuthResponse);
  //
  //     FB.Event.subscribe("auth.authResponseChange", event => {
  //       setIsLoggedIn(event.status === "connected");
  //     });
  //   });
  // }, []);

  console.log("isLoggedIn", isLoggedIn);

  if (!isLoggedIn)
    return null;

  return <button
    style={{
      position: "fixed",
      right: "1rem",
      bottom: "1rem",
      appearance: "none",
      WebkitAppearance: "none",
      cursor: "pointer",
      fontSize: "1.6rem",
      background: "none",
      border: "none",
      color: "white"
    }}
    type="button"
    onClick={() => userLogout()}
  >
    {translate.translate("logout")}
  </button>
}